import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { ControladorBase, VistaBase } from '@/components/a-interfaz/a-controlador';
import { Pedido } from '@/__env/lib/Ventas/Pedidos';
import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
import * as Pagos from '@/__env/lib/Ventas/Pagos';
import { isNumber, isString, isArray } from 'util';
import { Utiles } from '@/__env/pluggins/event-bus';
import router from '@/__env/router.index';
import _ from 'lodash';
import { Articulo } from '@/__env/lib/Articulos';
import { ControladorNuevoPedido, Item as ItemEdicion } from '@/views/a-pedido-cargar/controlador-pedido';
import { Cliente } from '@/__env/lib/Clientes';
import { Vendedor } from '@/__env/lib/Ventas/Vendedores';
import { Wait } from '@/__env/ext';
import { Item } from '@/__env/lib/Ventas/Pedidos/Item';
import { Envio } from '@/__env/lib/Ventas/Envios';
import { ControladorTunero } from '@/views/a-pedido-cargar/controlador-turnero';
import moment, { Moment } from 'moment';
import { Transporte } from '@/__env/lib/Expedicion/Transportes';


export class ControladorInterfaz extends ControladorBase
{
    constructor()
    {
        super();
        this.Configuracion = new ConfiguracionCargaPedido( this );
        this.Turnero = new ControladorTunero();
        this.Configuracion.Iniciar();
        this.EdicionPedido = new ControladorNuevoPedido( this );
        this.Vista.Titulo = 'Nuevo Pedido';
        this.Vista.Opciones.push();
    }

    public GuardarYContinuarSeleccionado: number = -1;
    public GuardarYContinuar: Pedido[] = [];
    public async SiguientePedido()
    {
        this.Vista.Estado = 'cargando';
        if ( this.GuardarYContinuar[this.GuardarYContinuarSeleccionado + 1] )
        {
            this.Pedido = this.GuardarYContinuar[this.GuardarYContinuarSeleccionado + 1];
            await this.EdicionPedido.Reiniciar();
            await Wait( 300 );
            await this.EdicionPedido.AbrirPedido( this.Pedido, true );
            this.GuardarYContinuarSeleccionado++;
            this.Vista.Estado = 'ok';
        } else
        {
            this.Vista.Estado = 'finalizado';
        }

    }

    public ArticuloSeleccionado: Articulo = new Articulo();
    public Pedido: Pedido = new Pedido();
    public EdicionPedido: ControladorNuevoPedido;
    public Configuracion: ConfiguracionCargaPedido;
    public Turnero: ControladorTunero;

    async Iniciar( ped?: Pedido | number | Pedido[] ): Promise<void>
    {
        this.Vista.Estado = 'cargando';
        this.Pedido = null;
        if ( ped )
        {
            if ( isNumber( ped ) )
            {
                this.Pedido = await Pedido.create( ped );
                if ( this.Pedido )
                {
                    await this.EdicionPedido.Reiniciar();
                    await Wait( 1000 );
                    await this.EdicionPedido.AbrirPedido( this.Pedido );
                }
            }
            else if ( ped instanceof Pedido )
            {
                this.Pedido = ped;
                await this.EdicionPedido.Reiniciar();
                await Wait( 1000 );
                await this.EdicionPedido.AbrirPedido( this.Pedido );
            }

            if ( isArray( ped ) )
            {
                this.GuardarYContinuar.clear();
                for ( let pedido of ped )
                {
                    if ( pedido.IdExterna && !pedido.Tipo.esNoEspecificado )
                    {
                        let e = await Pedido.createIdExterna( pedido.IdExterna, pedido.Tipo );
                        if ( e )
                        {
                            pedido = e;
                            if ( !pedido.Tags.Pendiente )
                            {
                                Utiles.Notificaciones.Alerta( `El pedido ${pedido.Id} ya fue procesado!` );
                            } else
                            {
                                this.GuardarYContinuar.push( pedido );
                            }
                        } else
                        {
                            this.GuardarYContinuar.push( pedido );
                        }
                    } else
                    {
                        this.GuardarYContinuar.push( pedido );
                    }

                }


            } else
            {
                if ( !this.Pedido || !this.Pedido.Existe )
                {
                    Utiles.Notificaciones.Error( '¡Pedido no existe!' );
                }
            }
        }


        if ( this.GuardarYContinuar.hasRows() )
        {
            await this.SiguientePedido();
        }
        else if ( !this.Pedido )
        {
            this.Pedido = new Pedido();
            await this.EdicionPedido.Reiniciar();
        }

        this.Vista.Estado = 'ok';
        this.Vista.BarraIzquierda.Modo = 'menu';
    }

    public UltimoGuardado: {
        Fecha: Moment,
        Total: number,
        Cliente: number,
        Vendedor: number,
        Tipo: string,
    }
        = {
            Fecha: null,
            Total: 0,
            Cliente: 0,
            Vendedor: 0,
            Tipo: '',
        };

    public ComprobarGuardadoAutomatico(): boolean
    {
        return this.UltimoGuardado.Total != this.EdicionPedido.Totales.Final ||
            this.UltimoGuardado.Cliente != this.EdicionPedido.Cliente.Id ||
            this.UltimoGuardado.Vendedor != this.EdicionPedido.Vendedor.Id ||
            this.UltimoGuardado.Tipo != this.EdicionPedido.Tipo.Id;
    }

    public async Guardar(): Promise<boolean>
    {
        let erro = await this.EdicionPedido.ComprobarErrores();
        if ( erro.hasRows() )
            return false;

        if ( !this.EdicionPedido.Cliente.Existe )
            if ( ! await this.EdicionPedido.Cliente.save() )
                return false;

        if ( !this.EdicionPedido.Envio.Existe )
            if ( ! await this.EdicionPedido.Envio.save() )
                return false;


        if ( this.EdicionPedido.Modo == 'plataformas' )
        {
            if ( this.EdicionPedido.Pagos.hasRows() )
            {
                for ( let pago of this.EdicionPedido.Pagos )
                {
                    pago.Plataforma = Pagos.Plataformas.toTipo( this.EdicionPedido.Tipo.Id );
                    pago.Cuenta = this.EdicionPedido.Tipo.Id;
                    pago.Modo = 'plataforma';
                    pago.Estado = Pagos.Estados.Autorizado;
                    pago.Cliente.Nombre = this.EdicionPedido.Cliente.Vista.Descripcion;
                    pago.Cliente.Documento = this.EdicionPedido.Cliente.Cuit ? this.EdicionPedido.Cliente.Cuit : this.EdicionPedido.Cliente.Documento;
                    pago.Cliente.Telefono = this.EdicionPedido.Cliente.Contacto.Telefono;
                    pago.Cliente.Email = this.EdicionPedido.Cliente.Contacto.Email;
                    pago.Cliente.Id = this.EdicionPedido.Cliente.Id;
                    pago.Fechas.Creacion = moment();
                    pago.Importes.Total = this.EdicionPedido.Totales.Final;
                    pago.Importes.Pagado = this.EdicionPedido.Totales.Final + this.EdicionPedido.Envio.Importes.Cliente;
                    pago.CargoPorEnvio = this.EdicionPedido.Envio.Importes.Cliente;
                    pago.Comision.Porcentaje = ( pago.Comision.Monto / pago.Importes.Total );
                    if ( !await pago.save() )
                        return false;
                    break;
                }

            }
        }

        this.Pedido.Cliente = this.EdicionPedido.Cliente;
        this.Pedido.Vendedor = this.EdicionPedido.Vendedor;
        this.Pedido.Envio = this.EdicionPedido.Envio;
        if ( (this.Pedido.Envio.Tipo.esPlataforma  || this.Pedido.Envio.Tipo.esCuentaCorriente) && ( !this.Pedido.Envio.EmpresaLogistica || !this.Pedido.Envio.EmpresaLogistica.Existe ) )
        {
            this.Pedido.Envio.EmpresaLogistica = await Transporte.create( this.Pedido.Cliente.TransportePredeterminado );
        }

        this.Pedido.Tipo = this.EdicionPedido.Tipo;

        if ( this.EdicionPedido.Modo == 'plataformas' )
        {
            this.Pedido.Cuenta = this.Pedido.Tipo.Id.toUpperCase();
        }

        this.Pedido.Items.clear();
        for ( let item of this.EdicionPedido.Items )
        {
            let peditem = new Item();
            peditem.Codigo = item.Articulo.Id;
            peditem.IdExterna = item.Articulo.Precio.IdPublicacion;
            peditem.Cliente = this.Pedido.Cliente.Id;
            peditem.Tipo = this.Pedido.Tipo;
            peditem.Cantidad = item.Cantidad;
            peditem.PrecioFijado = item.Articulo.Precio;
            this.Pedido.Items.push( peditem );
        }

        let e = await this.Pedido.save();
        if ( e )
        {
            if ( this.EdicionPedido.Modo == 'plataformas' )
                await this.Pedido.AgregarPagos( this.EdicionPedido.Pagos.filter( x => x.Existe ).map( x => x.Id.toString() ) );

            this.UltimoGuardado.Fecha = moment();
            this.UltimoGuardado.Total = this.EdicionPedido.Totales.Final;
            this.UltimoGuardado.Cliente = this.EdicionPedido.Cliente.Id;
            this.UltimoGuardado.Vendedor = this.EdicionPedido.Vendedor.Id;
            this.UltimoGuardado.Tipo = this.EdicionPedido.Tipo.Id;
        }
        this.EdicionPedido.ActualizarTotales();
        return e;
    }

    public async Reiniciar()
    {
        this.GuardarYContinuar.clear();
        this.GuardarYContinuarSeleccionado = -1;
        this.EdicionPedido.GuardarYContinuar = false;

        this.UltimoGuardado.Fecha = null;
        this.UltimoGuardado.Total = 0;
        this.UltimoGuardado.Cliente = 0;
        this.UltimoGuardado.Vendedor = 0;
        this.UltimoGuardado.Tipo = '';

        this.Pedido = new Pedido();
        await this.EdicionPedido.Reiniciar();
        this._onReiniciarTabla.dispatch();
        await Wait( 500 );
        if ( this.EdicionPedido.Modo == 'plataformas' )
            this.Vista.Estado = 'ok';
    }

    private _onReiniciarTabla = new SignalDispatcher();
    public get onReiniciarTabla() { return this._onReiniciarTabla.asEvent(); }

}

export class ConfiguracionCargaPedido
{
    constructor( controlador: ControladorInterfaz )
    {
        this.Controlador = controlador;
    }

    protected Controlador: ControladorInterfaz;

    public Opciones = {
        BuscadorArticulos: {
            MostrarImagenes: false,
            ExpandirDetalles: false,
            AgregaDirectamente: false,
            BusquedaExtendida: false,
            OcultarFueraDeLista: true,
            OcultarDesactivados: true,

        },

        Precios: {
            Mostrar: 'depende',
            MostrarDescuentos: 'nunca',

        },

        Mas: {
            GuardadoAutomatico: 'desactivado'
        },
        PanelDetalleArticulos: {
            PantallaPredeterminada: 0,
            Abrir: 'resolucion'
        }
    };


    public get usarPrecioNeto() { return this.Opciones.Precios.Mostrar == 'neto' || ( this.Opciones.Precios.Mostrar == 'depende' && this.Controlador.EdicionPedido.Tipo.Precio == 'neto' ); }
    public get usarPrecioFinal() { return !this.usarPrecioNeto; }

    Iniciar()
    {
        let js = localStorage.getItem( 'cfg_carga_pedidos' );
        if ( js )
        {
            let json = JSON.parse( js );
            this.Opciones = _.merge( this.Opciones, json );
        }
        this.Guardar();

        if ( this.Controlador.Configuracion.Opciones.PanelDetalleArticulos.Abrir == 'siempre' || ( !Utiles.VueRoot.$vuetify.breakpoint.smAndDown && this.Controlador.Configuracion.Opciones.PanelDetalleArticulos.Abrir == 'resolucion' ) )
        {
            this.Controlador.Vista.BarraDerecha.Modo = 'articulo-detalles';
        }

    }

    Guardar()
    {
        let json = this.Opciones;
        localStorage.setItem( 'cfg_carga_pedidos', JSON.stringify( json ) );
    }
}

//export const Controlador = new ControladorInterfaz();

